import { experiences } from "../data/content";
import { Reveal } from "./Reveal";
import { SectionHeader } from "./SectionHeader";
import "./Experience.css";

export function Experience() {
  return (
    <section id="experiencia" className="section container">
      <SectionHeader
        eyebrow="Trajetória"
        title="Experiência profissional"
        description="Onde apliquei essas competências em produção, com times e prazos reais."
      />

      <ol className="timeline">
        {experiences.map((exp, i) => (
          <Reveal key={`${exp.company}-${exp.period}`} delay={0.05 * i} as="li">
            <article className="timeline__item">
              <div className="timeline__marker" aria-hidden="true">
                <span className={exp.current ? "is-current" : undefined} />
              </div>

              <div className="timeline__body">
                <header className="timeline__head">
                  <div>
                    <h3 className="h3 timeline__role">{exp.role}</h3>
                    <p className="timeline__company">{exp.company}</p>
                  </div>
                  <span className="timeline__period">{exp.period}</span>
                </header>

                <ul className="timeline__highlights">
                  {exp.highlights.map((highlight) => (
                    <li key={highlight}>{highlight}</li>
                  ))}
                </ul>

                <ul className="tag-row timeline__stack">
                  {exp.stack.map((item) => (
                    <li key={item} className="tag">
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            </article>
          </Reveal>
        ))}
      </ol>
    </section>
  );
}
